import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "@/i18n";
import HomePage from "@/components/site/HomePage";
import Privacy from "@/components/site/Privacy";
import ContactPage from "@/components/site/ContactPage";

export default function App() {
    return (
        <div className="min-h-screen bg-navy-950 font-sans text-slate-300">
            <LanguageProvider>
                <BrowserRouter>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/contatti" element={<ContactPage />} />
                    </Routes>
                </BrowserRouter>
            </LanguageProvider>
            <Toaster
                theme="dark"
                position="bottom-center"
                toastOptions={{
                    style: {
                        background: "#0F2740",
                        border: "1px solid #2A4A6B",
                        color: "#F4F6F8",
                    },
                }}
            />
        </div>
    );
}
